var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Toolbar'),_c('v-content',[(_vm.view)?_c('Schools'):_c('Projects')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }